import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const OrderViewSkeleton = () => {
  return (
    <section className="myAccount-section">
      <div className="container-fluid container-lg">
        <div className="row">
          <div className="col-lg-12">
            <div className="acc-header py-3">
              {/* Left Side (Title + Order Info) */}
              <div className="myaccount-address">
                <h1 className="myaccount-title mb-2">
                  Order Invoice #: <Skeleton width={120} height={22} inline />
                </h1>
                <div className="order-invoice space-y-2">
                  <p>
                    Order Number: <Skeleton width={100} height={18} inline />
                  </p>
                  <p>
                    Invoice Date: <Skeleton width={100} height={18} inline />
                  </p>
                </div>
              </div>

              {/* Right Side (Buttons) */}
              <div className="reorder-download"></div>
            </div>
          </div>
        </div>

        <div className="row mt-3 mt-md-4 billingShipping-wrapper">
          {/* Billing & Shipping Address */}
          <div className="col-md-6">
            <div className="order-address">
              <div className="card order-address-card">
                <div className="card-header">
                  <h5>
                    <span className="wes wes-download"></span> Address
                  </h5>
                </div>
                <div className="card-body order-address-body">
                  <div className="row">
                    {/* Shipping Address */}
                    <div className="col-sm-6 col-md-6">
                      <div className="addressDetails">
                        <h6>Shipping Address</h6>
                        <address className="mt-3">
                          <Skeleton width={150} height={16} />
                          <Skeleton width={120} height={16} />
                          <Skeleton width={160} height={16} />
                          <Skeleton width={140} height={16} />
                          <Skeleton width={180} height={16} />
                        </address>
                        <div className="addressDetails-contact mt-3">
                          <p>
                            <b>Phone Number:</b>{" "}
                            <Skeleton width={120} height={16} inline />
                          </p>
                          <p>
                            <b>Attn To:</b>{" "}
                            <Skeleton width={120} height={16} inline />
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* Billing Address */}
                    <div className="col-sm-6 col-md-6">
                      <div className="addressDetails">
                        <h6>Billing Address</h6>
                        <address className="mt-3">
                          <Skeleton width={150} height={16} />
                          <Skeleton width={120} height={16} />
                          <Skeleton width={160} height={16} />
                          <Skeleton width={140} height={16} />
                          <Skeleton width={180} height={16} />
                        </address>
                        <div className="addressDetails-contact mt-3">
                          <p>
                            <b>Phone Number:</b>{" "}
                            <Skeleton width={120} height={16} inline />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Order Details */}
          <div className="col-md-6 mt-3 mt-md-0">
            <div className="order-address">
              <div className="card order-address-card">
                <div className="card-header">
                  <h5>
                    <span className="wes wes-download"></span> Order Details
                  </h5>
                </div>
                <div className="card-body order-address-body">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="orderStatus mb-3">
                        <h6>Order Status:</h6>
                        <Skeleton width={100} height={16} inline />
                      </div>
                      <div className="orderStatus mb-3">
                        <h6>Payment:</h6>
                        <Skeleton circle width={24} height={24} inline />{" "}
                        <Skeleton width={100} height={16} inline />
                      </div>
                      <div className="orderStatus mb-3">
                        <h6>Users:</h6>
                        <Skeleton width={120} height={16} inline />
                      </div>
                      <div className="orderStatus">
                        <h6>Shipping:</h6>
                        <Skeleton width={200} height={16} inline />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Order Items */}
          <div className="col-lg-12 mt-3 mt-md-4 billingShipping-wrapper">
            <div className="order-address">
              <div className="card order-address-card">
                <div className="card-header">
                  <h5>
                    <span className="wes wes-download"></span> Order Details
                  </h5>
                </div>
                <OrderCartItemSkeleton />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export const OrderCartItemSkeleton = () => {
  return (
    <div className="card-body order-address-body">
      <div className="row">
        <div className="col-lg-12">
          <div className="myAccount-orderItem flex justify-between">
            {/* Left Side */}
            <div className="myAccount-orderItem-lft flex gap-3">
              <div className="myAccount-orderItem-img">
                <Skeleton width={80} height={80} />
              </div>
              <div className="myAccount-orderItem-details">
                <h3>
                  <Skeleton width={250} height={16} />
                </h3>
                <div className="orderItem-features mt-2">
                  <ul>
                    <li>
                      Qty: <Skeleton width={30} inline />
                    </li>
                    <li>
                      Code: <Skeleton width={60} inline />
                    </li>
                    <li className="orderItem-features-price">
                      <Skeleton width={50} inline />
                    </li>
                  </ul>
                </div>
                <div className="product-quantity mt-2">
                  <Skeleton width={120} height={32} />
                </div>
              </div>
            </div>
            {/* Right Side */}
            <div className="myAccount-orderItem-rht flex flex-col gap-2">
              <Skeleton width={100} height={36} />
              <Skeleton width={120} height={40} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
